import { useState } from 'react';

const ToggleContainer = (props) => {
  const [open, setOpen] = useState(props.open);
  const [animation, setAnimation] = useState(props.open);

  const toggleHandler = () => {
    setOpen(!open);

    animation
      ? setAnimation(!animation)
      : setTimeout(() => setAnimation(!animation), 100);
  };

  const { children } = props;

  return children({
    open: open,
    toggle: toggleHandler,
    animation: animation,
  });
};

export default ToggleContainer;
